// src/pages/Contact.js
import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p>We'd love to hear from you! Reach us directly through the following methods:</p>
      <div className="contact-content">
        <div className="contact-info">
          <h3>Email Us</h3>
          <p><a href="mailto:everbloominteriors@gmail.com">everbloominteriors@gmail.com</a></p>
          <h3>WhatsApp Us</h3>
          <p><a href="https://wa.me/918789853321" target="_blank" rel="noopener noreferrer">+91-8789853321</a></p>
          <h3>Call Us</h3>
          <p>+91-8789853321</p>
          <h3>Our Address</h3>
          <p>The Sai Regency, Baliguma, Dimna, Mango, Jamshedpur - 831012</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;